export default function Cookies() {
  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 data-testid="cookies-title" className="text-4xl font-bold text-white mb-4 section-marker font-mono">Cookie Policy</h1>
          <p className="text-xs font-mono text-zinc-500 mb-12">Last updated: February 1, 2026</p>
          <div className="space-y-8">
            {[
              { title: 'What Are Cookies', body: 'Cookies are small text files stored on your device when you visit our website. They help us provide essential functionality and improve your experience.' },
              { title: 'Essential Cookies', body: 'These cookies are necessary for the website to function. They include authentication tokens, session identifiers, and CSRF protection. You cannot disable these.' },
              { title: 'Analytics Cookies', body: 'We use anonymized analytics to understand how visitors use our site. No personal data is collected. You can opt out via your browser settings.' },
              { title: 'Preference Cookies', body: 'These remember your settings like theme preferences and dashboard layout. They are optional but improve your experience.' },
              { title: 'Managing Cookies', body: 'You can control cookies through your browser settings. Note that disabling essential cookies may prevent you from using certain features of the Service.' },
              { title: 'Contact', body: 'For questions about our cookie policy, email privacy@clawstinger.com.' },
            ].map((s, i) => (
              <div key={i}>
                <h2 className="text-lg font-mono text-white font-bold mb-2">{s.title}</h2>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
